import type { EntityType } from '@stw/types';

import { stwFetch } from '@/utils/stwFetch';

export interface BookmarkResponse {
  is_bookmarked: boolean;
}

/**
 * Add an entity to bookmarks
 */
export const addBookmark = async (
  entityType: EntityType,
  entityId: string
): Promise<BookmarkResponse> => {
  const response = await stwFetch('POST', `/user/${entityType}/bookmark`, {
    [`${entityType}Id`]: entityId,
  });
  return response.data;
};

/**
 * Remove an entity from bookmarks
 */
export const removeBookmark = async (
  entityType: EntityType,
  entityId: string
): Promise<BookmarkResponse> => {
  const response = await stwFetch('DELETE', `/user/${entityType}/bookmark`, {
    [`${entityType}Id`]: entityId,
  });
  return response.data;
};

/**
 * Check if an entity is bookmarked
 */
export const checkBookmark = async (
  entityType: EntityType,
  entityId: string
): Promise<BookmarkResponse> => {
  const response = await stwFetch(
    'GET',
    `/user/${entityType}/bookmark?${entityType}Id=${entityId}`
  );
  return response.data;
};
